const MODULE_NAME = 'fulcrum/container/Report/WeeklyStatus'

const MOUNT = 'fulcrum/container/Report/WeeklyStatus/MOUNT'
const ON_INPUT_CHANGE = 'fulcrum/container/Report/WeeklyStatus/INPUT_CHANGE'
const ON_ENTER = 'fulcrum/container/Report/WeeklyStatus/ON_ENTER'
const ON_SKU_CHANGE = 'fulcrum/container/Report/WeeklyStatus/ON_SKU_CHANGE'
const CLEAR_SKU = 'fulcrum/container/Report/WeeklyStatus/CLEAR_SKU'
const CLEAR_SEARCH = 'fulcrum/container/Report/WeeklyStatus/CLEAR_SEARCH'
const CLEAR_TABLE_FILTER = 'fulcrum/container/Report/WeeklyStatus/CLEAR_TABLE_FILTER'
const CLEAR_TABLE_SORT = 'fulcrum/container/Report/WeeklyStatus/CLEAR_TABLE_SORT'
const UPDATE_SKU = 'fulcrum/container/Report/WeeklyStatus/UPDATE_SKU'
const UPDATE_SEARCH = 'fulcrum/container/Report/WeeklyStatus/UPDATE_SEARCH'
const UPDATE_TABLE_FILTER = 'fulcrum/container/Report/WeeklyStatus/UPDATE_TABLE_FILTER'
const UPDATE_TABLE_SORT = 'fulcrum/container/Report/WeeklyStatus/UPDATE_TABLE_SORT'
const UPDATE_REPORT_DURATION = 'fulcrum/container/Report/WeeklyStatus/UPDATE_REPORT_DURATION'

const FETCH_PRODUCT_SKUS = 'fulcrum/container/Report/WeeklyStatus/FETCH_PRODUCT_SKUS'
const FETCH_PRODUCT_SKUS_START = 'fulcrum/container/Report/WeeklyStatus/FETCH_PRODUCT_SKUS_START'
const FETCH_PRODUCT_SKUS_SUCCESS = 'fulcrum/container/Report/WeeklyStatus/FETCH_PRODUCT_SKUS_SUCCESS'
const FETCH_PRODUCT_SKUS_ERROR = 'fulcrum/container/Report/WeeklyStatus/FETCH_PRODUCT_SKUS_ERROR'

const FETCH_WEEKLYSTATUS_REPORT = 'fulcrum/container/Report/WeeklyStatus/FETCH_WEEKLYSTATUS_REPORT'
const FETCH_WEEKLYSTATUS_REPORT_START = 'fulcrum/container/Report/WeeklyStatus/FETCH_WEEKLYSTATUS_REPORT_START'
const FETCH_WEEKLYSTATUS_REPORT_SUCCESS = 'fulcrum/container/Report/WeeklyStatus/FETCH_WEEKLYSTATUS_REPORT_SUCCESS'
const FETCH_WEEKLYSTATUS_REPORT_ERROR = 'fulcrum/container/Report/WeeklyStatus/FETCH_WEEKLYSTATUS_REPORT_ERROR'


const REPORT_FIELDS = [
  'projectId',
  'partnerSiteName',
  'projectName',
  'lifecycle',
  'workWeek',
  'workYear',
  'weekStatus',
  'role',
  'userName'
]

export {
  MODULE_NAME,
  MOUNT,
  ON_INPUT_CHANGE,
  ON_ENTER,
  ON_SKU_CHANGE,
  CLEAR_SKU,
  CLEAR_SEARCH,
  CLEAR_TABLE_FILTER,
  CLEAR_TABLE_SORT,
  UPDATE_SKU,
  UPDATE_SEARCH,
  UPDATE_TABLE_FILTER,
  UPDATE_TABLE_SORT,
  UPDATE_REPORT_DURATION,
  FETCH_PRODUCT_SKUS,
  FETCH_PRODUCT_SKUS_START,
  FETCH_PRODUCT_SKUS_SUCCESS,
  FETCH_PRODUCT_SKUS_ERROR,
  FETCH_WEEKLYSTATUS_REPORT,
  FETCH_WEEKLYSTATUS_REPORT_START,
  FETCH_WEEKLYSTATUS_REPORT_SUCCESS,
  FETCH_WEEKLYSTATUS_REPORT_ERROR,
  REPORT_FIELDS,
}